import * as React from "react";
import i18n from "../../../../i18n/i18n";
import {Popup} from "../popup/popup";

interface WarningFiltersPopupProps {
    displayPopup: boolean;
    actionPopup: () => void;
    closePopup: () => void;
}

export default function WarningFiltersPopup(props: WarningFiltersPopupProps): React.ReactElement {
    const content = <div>
        <p>{i18n.t("transportation.order.warningPopup.content1")}</p>
        <p>{i18n.t("transportation.order.warningPopup.content2")}</p>
    </div>;

    return (
        <Popup
            open={props.displayPopup}
            className="warning-popup popup-with-warning-button-color"
            header={i18n.t("transportation.order.warningPopup.header")}
            content={content}
            actionText={i18n.t("transportation.order.warningPopup.actionText")}
            action={props.actionPopup}
            cancel={props.closePopup}
            testId="warning-popup"
        />
    );
}